!(function () {
  "use strict";
  var t,
    e = {
      2952: function (t, e, i) {
        var n = i(4306),
          a = i(8764),
          r = i(4394),
          o = i(8678),
          s = i(6486);
        const { fetch: c } = i.g;
        i(4486);
        const { CART: d, CUSTOMER_EMAIL: l, SHOPIFY_DOMAIN: h, GLOBALS: u } = window;
        n.Z.store("main", {
          shopifyDomain: h,
          customerEmail: l,
          globals: u,
          activeProductVariantId: null,
          isMiniCartOpen: !1,
          currentDropdown: null,
          isNavOpen: !1,
          isMobileNavOpen: !1,
          isNavigatingToCheckout: !1,
          isSearchOpen: !1,
          isWholesale: !1,
          isTrade: !1,
          cart: d || null,
          pendingUpdateVariantId: null,
          pendingAddVariantId: null,
          addedVariantIds: [],
          isCartUpdating: !1,
          init() {
            this.onScroll(),
              document.addEventListener("scroll", () => {
                this.onScroll();
              });
          },
          onScroll() {
            window.scrollY > 100 ? (this.isScrolled = !0) : (this.isScrolled = !1);
          },
          toggleMobileNav() {
            (this.isMobileNavOpen = !this.isMobileNavOpen),
              this.isMobileNavOpen ? document.documentElement.classList.add("overflow-hidden") : document.documentElement.classList.remove("overflow-hidden"),
              (this.isMiniCartOpen = !this.isMobileNavOpen && this.isMiniCartOpen),
              (this.isSearchOpen = !this.isMobileNavOpen && this.isSearchOpen);
          },
          setMiniCartOpen(t) {
            (this.isMiniCartOpen = t),
              (this.isSearchOpen = !1),
              (this.isMobileNavOpen = !1),
              this.isMiniCartOpen ? document.documentElement.classList.add("overflow-hidden") : document.documentElement.classList.remove("overflow-hidden");
          },
          removeHeaderSpacer() {
            const t = document.querySelector(".header-spacer");
            t?.parentNode.removeChild(t);
          },
          setHeaderColors(t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            document.body.style.setProperty("--bg-header", t), e && document.body.style.setProperty("--header-text-color", e);
          },
          resetHeaderColors() {
            document.body.style.setProperty("--bg-header", "#F6F4EF"), document.body.style.setProperty("--header-text-color", "#363232");
          },
          closeMenus() {
            (this.isNavOpen = !1),
              (this.isMobileNavOpen = !1),
              (this.isSearchOpen = !1),
              (this.currentDropdown = null),
              document.documentElement.classList.remove("overflow-hidden"),
              setTimeout(() => {
                this.resetHeaderColors();
              }, 200);
          },
          setActiveVariantId(t) {
            (this.activeProductVariantId = t), window.history && window.history.replaceState && window.history.replaceState({}, window.title, `${window.location.pathname}?variant=${t}`);
          },
          getDiscount(t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return e ? t - t * { wholesale: 0.5, trade: 0.2 }[e] : t;
          },
          getCartTotal() {
            if (!this.cart) return 0;
            // if (this.isWholesale) {
            //   let t = 0;
            //   return (
            //     this.cart.items.forEach((e) => {
            //       "wholesale" === e.properties.customerType ? (t += this.getDiscount(e.final_price, "wholesale")) : (t += e.final_price);
            //     }),
            //     t
            //   );
            // }
            // if (this.isTrade) {
            //   let t = 0;
            //   return (
            //     this.cart.items.forEach((e) => {
            //       "MINNA" === e.vendor ? (t += this.getDiscount(e.final_price, "trade")) : (t += e.final_price);
            //     }),
            //     t
            //   );
            // }
            return this.cart.total_price;
          },
          gtagItemFromLine(t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
            return {
              item_id: t.sku || t.id,
              item_name: t.product_title,
              currency: "USD",
              item_brand: t.vendor,
              item_category: t.product_type,
              item_variant: t.title,
              discount: t.total_discount ? t.total_discount / 100 : 0,
              discount: t.final_price ? t.final_price / 100 : 0,
              quantity: e,
            };
          },
          addVariant(t) {
            let { variantId: e, quantity: i = 1, properties: n = {}, openCart: a = !0 } = t;
            return (
              (this.pendingAddVariantId = e),
              (function (t) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                  i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return c("/cart/add.js", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: t, quantity: e, properties: i }] }) });
              })(e, i, n)
                .then((t) => t.json())
                .then((t) => {
                  if (t.items) {
                    const e = t.items,
                      i = this.cart.items;
                    if (gtag) {
                      const t = (0, s.reduce)(e, (t, e) => t + (e.final_price || 0), 0);
                      gtag("event", "add_to_cart", { currency: "USD", value: t, items: e.map((t) => this.gtagItemFromLine(t, t.quantity)) });
                    }
                    for (let t = 0; t < e.length; t++) {
                      const n = e[t],
                        a = i.find((t) => t.key == n.key);
                      a ? (a.quantity = n.quantity) : i.unshift(n);
                    }
                    (this.pendingAddVariantId = null), (this.cart = { ...this.cart, ...this.calculateItems(i) }), a && this.setMiniCartOpen(!0);
                    this.checkWallpaper(this.cart.items);
                  } else if (t.description) throw (alert(t.description), new Error(t.description));
                  const e = t.items;
                  if (gtag) {
                    const t = (0, s.reduce)(e, (t, e) => t + (e.final_price || 0), 0);
                    gtag("event", "add_to_cart", { currency: "USD", value: t, items: e.map((t) => this.gtagItemFromLine(t, t.quantity)) });
                  }
                  a && this.setMiniCartOpen(!0);
                })
                .catch((t) => {
                  throw ((this.pendingAddVariantId = null), t);
                })
            );
          },
          updateColors(t, e) {
            t && document.body.style.setProperty("--bg-main", t), e && document.body.style.setProperty("--bg-header", e);
          },
          updateVariantQuantity(t, e, m) {
            return (
              (this.pendingUpdateVariantId = t),
              (function (t) {
                let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                if (m && e < m && m > 1) e++;
                return c("/cart/change.js", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: `${t}`, quantity: e }) });
              })(t, e)
                .then((t) => t.json())
                .then((t) => {
                  (this.pendingUpdateVariantId = null), (this.cart = t);
                  this.checkWallpaper(this.cart.items);
                })
                .catch((t) => {
                  throw ((this.pendingUpdateVariantId = null), t);
                })
            );
          },
          getCouponUrl(t) {
            return this.isWholesale ? t.concat("?discount=wholesale") : this.isTrade ? t.concat("?discount=trade-customer") : t;
          },
          navigateToCheckout() {
            this.isNavigatingToCheckout = !0;
            const t = ((t) => {
              let { cart: e, shopifyDomain: i, customerEmail: n } = t;
              return "/checkout";
            })({ cart: this.cart, shopifyDomain: this.shopifyDomain, customerEmail: this.customerEmail });
            gtag && gtag("event", "begin_checkout", { currency: "USD", value: this.cart.total_price / 100, items: this.cart.items.map((t) => this.gtagItemFromLine(t, t.quantity)) }),
              (window.location = this.getCouponUrl(t)),
              setTimeout(() => {
                this.isNavigatingToCheckout = !1;
              }, 1500);
          },
          setSearchOpen(t) {
            (this.isSearchOpen = t), (this.isMobileNavOpen = !t && this.isMobileNavOpen), (this.isMiniCartOpen = !t && this.isMiniCartOpen);
          },
          fetchCart() {
            return (
              (this.isCartUpdating = !0),
              c("/cart.json")
                .then((t) => t.json())
                .then((t) => {
                  (this.isCartUpdating = !1), (this.cart = t);
                })
                .catch((t) => {
                  throw ((this.isCartUpdating = !1), t);
                })
            );
          },
          updateCartAttributes(t) {
            return (
              (this.isCartUpdating = !0),
              ((e = t), c("/cart/update.js", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(e) }))
                .then((t) => t.json())
                .then((t) => {
                  (this.isCartUpdating = !1), (this.cart = t);
                })
                .catch((t) => {
                  throw ((this.isCartUpdating = !1), t);
                })
            );
            var e;
          },
          calculateItems(t) {
            return { item_count: t.reduce((t, e) => t + (e.quantity || 0), 0), total_price: t.reduce((t, e) => t + (e.discounted_price || 0) * e.quantity, 0) };
          },
          graphQl(t) {
            return ((t) =>
              c("/api/2022-10/graphql.json", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json", "X-Shopify-Storefront-Access-Token": "TOKEN" },
                body: JSON.stringify({ query: t }),
              }).then((t) => t.json()))(t);
          },
          checkWallpaper(items) {
            if (items) {
              const setup_item_found = items.filter((i) => (i.properties._setup > 0 && i.quantity <= i.properties._setup));
              const setup_fee_found = items.find((i) => (i.id == 48457692807478));

              const rush_item_found = items.filter((i) => (i.variant_title && i.variant_title.includes("Add rush printing")));
              const rush_fee_found = items.find((i) => (i.id == 48459939807542));

              if (setup_item_found.length && !setup_fee_found) {
                // add setup
                this.addVariant({variantId: 48457692807478, quantity: setup_item_found.length, properties: {_minQuantity: 1}});
              }
              else if (!setup_item_found.length && setup_fee_found) {
                // remove setup
                this.updateVariantQuantity(48457692807478, 0);
              }
              else if (setup_item_found.length && setup_fee_found && setup_fee_found.quantity !== setup_item_found.length) {
                // adjust setup fees up or down
                this.updateVariantQuantity(48457692807478, setup_item_found.length);
              }

              if (rush_item_found.length && !rush_fee_found) {
                // add rush
                this.addVariant({variantId: 48459939807542, quantity: rush_item_found.length, properties: {_minQuantity: 1}});
              }
              else if (!rush_item_found.length && rush_fee_found) {
                // remove rush
                this.updateVariantQuantity(48459939807542, 0);
              }
              else if (rush_item_found.length && rush_fee_found && rush_fee_found.quantity !== rush_item_found.length) {
                // adjust rush fees up or down
                this.updateVariantQuantity(48459939807542, rush_item_found.length);
              }
            }
          },
        }),
          n.Z.data("productForm", (t, e, i) => {
            const a =
                (function () {
                  let t;
                  const e = new URLSearchParams(location.search);
                  for (const [i, n] of e) "variant" === i && n && (t = n);
                  return t;
                })() || e,
              r = t.find((t) => t.id == (i ? a : e));
            t.forEach((t) => {
              const { inventoryManagement: e, inventoryQuantity: i, inventoryPolicy: n, title: a } = t;
              (t.minQuantity = t.defaultQuantity),
                (t.maxQuantity = 999999),
                (t.madeToOrderThreshold = 999999),
                (t.availableYardage = 0),
                "Fabric by the Yard" === t.productType && (!e && i < 1 && "continue" === n ? (t.minQuantity = 3) : (t.madeToOrderThreshold = i)),
                i > 0 && "continue" !== n && (t.maxQuantity = i),
                "continue" === n && "Yard" !== a && (t.madeToOrderThreshold = i);
            });
            const o = n.Z.reactive({ activeVariant: r });
            return (
              n.Z.effect(() => {
                const e = n.Z.store("main").activeProductVariantId;
                if (i) {
                  const i = t.find((t) => t.id == e);
                  i && (o.activeVariant = i);
                }
              }),
              {
                isOptionValueSelected(t, e) {
                  return (t = parseInt(t.replace("option", "")) - 1), this.reactiveData.activeVariant?.optionValues[t] == e;
                },
                isOptionAvailable(t, e) {
                  t = parseInt(t.replace("option", "")) - 1;
                  const i = [...this.reactiveData.activeVariant.optionValues];
                  i[t] = e;
                  const n = this.variants.find((t) => JSON.stringify(t.optionValues) == JSON.stringify(i));
                  return !!n && n.isAvailable;
                },
                onOptionChanged(t, e, el) {
                  // get option index, start at 0
                  t = parseInt(t.replace("option", "")) - 1;
                  const a = [...this.reactiveData.activeVariant.optionValues];
                  // assign option value to active from clicked
                  a[t] = e;

                  // if in the extended options view, set collapsed button value
                  if (el.parentElement.previousElementSibling.tagName == 'BUTTON') {
                    const btn = el.parentElement.previousElementSibling;
                    const optionCopy = el.cloneNode(true).childNodes;
                    btn.firstElementChild.innerHTML = '';
                    el.childNodes.forEach(function(item){
                      const clone = item.cloneNode(true);
                      btn.firstElementChild.appendChild(clone);
                    });
                  }

                  let r = this.variants.find((t) => JSON.stringify(t.optionValues) == JSON.stringify(a));
                  const prev_variant = this.reactiveData.activeVariant;
                  if (!r) {
                    r = this.variants.find((t) => JSON.stringify(t.optionValues).includes(JSON.stringify(e)));
                    this.reactiveData.hasOptions = false;
                  }
                  r && (i && n.Z.store("main").setActiveVariantId(r.id), (this.reactiveData.activeVariant = r));
                  if (r && (this.quantity < r.defaultQuantity || (prev_variant.optionValues[0] == "Yard" && t == 0) ))
                    this.quantity = r.defaultQuantity;
                },
                checkHasOptions(option) {
                  if (option > 1) {
                    const index = option - 1;
                    const active_variant = this.reactiveData.activeVariant;
                    const options = this.variants.filter((i) => i.optionValues[index - 1] == active_variant.optionValues[index - 1] );
                    if (options.length > 1) return true;
                    else return false;
                  }
                  else return true;
                },
                changeActiveVariant(t) {
                  const e = this.variants.find((e) => e.id == t);
                  e && i && n.Z.store("main").setActiveVariantId(e.id), (this.reactiveData.activeVariant = e);
                },
                checkIsBackorder() {
                  const { inventoryQuantity: t, inventoryPolicy: e, hasPreorder: i, title: n } = this.reactiveData.activeVariant;
                  return !(!this.exceedsAvailable || "Yard" === n) || (t < 1 && "continue" === e && !i && "Yard" !== n);
                },
                checkIsMadeToOrder() {
                  const { title: t, inventoryManagement: e, inventoryQuantity: i, inventoryPolicy: n, isAvailable: a } = this.reactiveData.activeVariant;
                  return !(!this.exceedsAvailable || "Yard" !== t) || ("Yard" === t && !e && i < 1 && "continue" === n) || !(!a || e);
                },
                checkIsPreorder() {
                  return !!this.reactiveData.activeVariant.hasPreorder;
                },
                incrementQuantity() {
                  const { maxQuantity: t, madeToOrderThreshold: e } = this.reactiveData.activeVariant;
                  (t && this.quantity >= t) || (this.quantity++, e && this.quantity > e && (this.exceedsAvailable = !0));
                },
                decrementQuantity() {
                  const { minQuantity: t, madeToOrderThreshold: e } = this.reactiveData.activeVariant;
                  (t && this.quantity <= t) || (this.quantity--, e && this.quantity <= e && (this.exceedsAvailable = !1));
                },
                getAtcText() {
                  return this.checkIsBackorder() && !this.checkIsMadeToOrder() ? "Backorder" : this.checkIsMadeToOrder() ? "Made to Order" : "Add to Cart";
                },
                reactiveData: o,
                variants: t,
                quantity: o.activeVariant.defaultQuantity,
                exceedsAvailable: !1,
              }
            );
          }),
          n.Z.directive("price", (t, e, i) => {
            let { expression: n } = e,
              { evaluateLater: a, effect: r } = i,
              o = a(n);
            r(() => {
              o((e) => {
                t.innerHTML = ((t) => {
                  let e = t / 100;
                  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(e).replace(/(\.|,)00$/g, "");
                })(e);
              });
            });
          }),
          n.Z.plugin(a.Z),
          n.Z.plugin(r.Z),
          n.Z.plugin(o.Z),
          (window.Alpine = n.Z),
          window.Alpine.start();
        const { HYDRATE_VARIANT_ID: p } = window,
          v = new URLSearchParams(window.location.search),
          m = Object.fromEntries(v.entries()),
          y = Number(m.variant) || p;
        y && Alpine.store("main").setActiveVariantId(y);
      },
      720: function () {},
    },
    i = {};
  function n(t) {
    var a = i[t];
    if (void 0 !== a) return a.exports;
    var r = (i[t] = { id: t, loaded: !1, exports: {} });
    return e[t].call(r.exports, r, r.exports, n), (r.loaded = !0), r.exports;
  }
  (n.m = e),
    (t = []),
    (n.O = function (e, i, a, r) {
      if (!i) {
        var o = 1 / 0;
        for (l = 0; l < t.length; l++) {
          (i = t[l][0]), (a = t[l][1]), (r = t[l][2]);
          for (var s = !0, c = 0; c < i.length; c++)
            (!1 & r || o >= r) &&
            Object.keys(n.O).every(function (t) {
              return n.O[t](i[c]);
            })
              ? i.splice(c--, 1)
              : ((s = !1), r < o && (o = r));
          if (s) {
            t.splice(l--, 1);
            var d = a();
            void 0 !== d && (e = d);
          }
        }
        return e;
      }
      r = r || 0;
      for (var l = t.length; l > 0 && t[l - 1][2] > r; l--) t[l] = t[l - 1];
      t[l] = [i, a, r];
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, { a: e }), e;
    }),
    (n.d = function (t, e) {
      for (var i in e) n.o(e, i) && !n.o(t, i) && Object.defineProperty(t, i, { enumerable: !0, get: e[i] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.nmd = function (t) {
      return (t.paths = []), t.children || (t.children = []), t;
    }),
    (n.j = 348),
    (function () {
      var t = { 348: 0 };
      n.O.j = function (e) {
        return 0 === t[e];
      };
      var e = function (e, i) {
          var a,
            r,
            o = i[0],
            s = i[1],
            c = i[2],
            d = 0;
          if (
            o.some(function (e) {
              return 0 !== t[e];
            })
          ) {
            for (a in s) n.o(s, a) && (n.m[a] = s[a]);
            if (c) var l = c(n);
          }
          for (e && e(i); d < o.length; d++) (r = o[d]), n.o(t, r) && t[r] && t[r][0](), (t[r] = 0);
          return n.O(l);
        },
        i = (self.webpackChunkbf_shopify_os2 = self.webpackChunkbf_shopify_os2 || []);
      i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
    })(),
    n.O(void 0, [216], function () {
      return n(2952);
    });
  var a = n.O(void 0, [216], function () {
    return n(720);
  });
  a = n.O(a);
})();
